import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.page.html',
  styleUrls: ['./modal.page.scss'],
})
export class ModalPage implements OnInit {

  toast: any;
  hideFavoritingFeature: boolean;
  headerBranding: any;
  clientCandidateNotes = [];
  clientBallotMeasureNotes = [];
  preventAddressSave: boolean;
  hideBPspecificPages: boolean;
  isBallotpediaWebApp: boolean;
  collectAnalytics: boolean;

  // These are the props (values) the Modal Component can accept:
  @Input() ballotmeasure: any;
  @Input() candidateInfo: any;
  @Input() raceInfo: any;
  @Input() volunteerCandidate: any;
  @Input() saved: any;



  constructor(
    private modalController: ModalController, 
    public toastController: ToastController, 
    private navController: NavController,
    public httpClient: HttpClient,
    private configService: ConfigService,
    private analyticsService: AnalyticsService
  ) { }


  async ngOnInit(){

    let res = await this.configService.getConfiguration();
    this.hideFavoritingFeature = res["hideFavoritingFeature"];
    this.headerBranding = res["headerBranding"];
    this.clientCandidateNotes = res["candidateNotes"];
    this.clientBallotMeasureNotes = res["ballotMeasureNotes"];
    this.preventAddressSave = res["preventAddressSave"];
    this.hideBPspecificPages = res["hideBPspecificPages"];
    this.isBallotpediaWebApp = res["isBallotpediaWebApp"];
    this.collectAnalytics = res["collectAnalytics"];

    console.log("CANDIDATE INFO");
    console.log(this.candidateInfo);
    console.log(this.ballotmeasure);
  } // Empty

  onSaveClickCandidate() {

    // If the candidate ID already exists in favorited Array, remove from array
    // Else, add to array
    
    let index = this.saved.savedCandidates.indexOf(this.candidateInfo.id);
    if (index > -1) {
      this.saved.savedCandidates.splice(index, 1);
      //this.showToast('Unsaved!');
    } else {
      this.saved.savedCandidates.push(this.candidateInfo.id);
      //this.showToast('Saved!');
    }

  }

  // save a volunteer candidate
  onClickSaveVolunteerCandidate() {
    // If the candidate ID already exists in volunteer favorited Array, remove from array
    // Else, add to array
    let index = this.saved.savedVolunteerCandidates.indexOf(this.volunteerCandidate.id);
    
    if (index > -1) {
      this.saved.savedVolunteerCandidates.splice(index, 1);
    } else {
      this.saved.savedVolunteerCandidates.push(this.volunteerCandidate.id);
    }
  }


  onClickMeasure(choice) {

    if(this.preventAddressSave) {
      return;
    }

    // Get index (if exists) of current ballot measure from saved array.
    let index = this.saved.savedBallotMeasures.map(function(bm) { return bm.id; }).indexOf(this.ballotmeasure.id);
    
    // If already exists and choice did not change, remove the saved bm.
    if(index > -1 && this.saved.savedBallotMeasures[index].choice === choice ? true : false) {
      this.saved.savedBallotMeasures.splice(index, 1);
     // this.showToast('Unsaved!');

      // If already exists and choice did change, update choice. 
    } else if (index > -1) {
      this.saved.savedBallotMeasures[index].choice = choice;
     // this.showToast('Saved');
      // if does not exist at all, save choice. 
    } else {
      let id = this.ballotmeasure.id;
      this.saved.savedBallotMeasures.push({
        id, 
        choice
      });    
     // this.showToast('Saved!');
    }
  
  };

  // Class for yes or no selection for ballot meausures:
  getClass(choice) {
    if (choice === 'yes') {
      return this.saved.savedBallotMeasures.findIndex(bm => bm.id === this.ballotmeasure.id && bm.choice === choice) > -1 ? 'yes-selected' : 'unselected';
    } else if (choice === 'no') {
      return this.saved.savedBallotMeasures.findIndex(bm => bm.id === this.ballotmeasure.id && bm.choice === choice) > -1 ? 'no-selected' : 'unselected';
    } 
    
  }

  visitExternalLink(URL: string, trackEvent = null) {
    window.open(URL, `_system`);
    if(trackEvent === 'trackCandidateProfileEvent') {
      if(this.collectAnalytics) {
        this.analyticsService.trackEvent('visit candidate profile');
      }
    }
  }


  getClientCandidateText(id, area) {
    let note = this.clientCandidateNotes.find(item => item.candidateId === id);
    
    if (area === 'ballot' && note && note.ballotText) {
        return note.ballotText;
    } else if (area === 'modal' && note && note.modalText) {
      return note.modalText;
    }
    
  }

  getClientBmText(id, area) {
    let note = this.clientBallotMeasureNotes.find(item => item.bmId === id);
    console.log(note);
    if (area === 'ballot' && note && note.ballotText) {
        return note.ballotText;
    } else if (area === 'modal' && note && note.modalText) {
      return note.modalText;
    }
    
  }

  showToast(message) {
    this.toast = this.toastController.create({
      message: message,
      duration: 1000,
      cssClass:"toast-styles"
    }).then((toastData)=>{
      toastData.present();
    });
  }
  HideToast(){
    this.toast = this.toastController.dismiss();
  }

  async reportError() {
    await this.modalController.dismiss();
    this.navController.navigateForward(`/feedback`);

  }

  // On modal close, send back the saved object to the Ballot component:

  async closeModal() {
      console.log('this.saved on modal close');
      console.log(this.saved);
      await this.modalController.dismiss(this.saved);
  }

}
